import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const PremiumLozengeLoadable: LoadableType<{}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PremiumLozenge" */ '../src/Lozenge/PremiumLozenge.tsx'
			)
		).PremiumLozenge,
});

export { PremiumLozenge as PremiumLozengeUi } from '../src/Lozenge/ui/PremiumLozenge.tsx';
